__turbopack_context__.v({
  "articles": "EncyclopediaCategory-module-scss-module__r54j5G__articles",
  "categories-grid": "EncyclopediaCategory-module-scss-module__r54j5G__categories-grid",
  "sub-categories": "EncyclopediaCategory-module-scss-module__r54j5G__sub-categories",
});
